import React, { useEffect, useState } from "react";
import { getGiftCardsAction } from "../../../../../../redux/services/wallet-info/walletInfoServices";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Empty, Flex, Row, Typography } from "antd";
import { colors } from "../../../../../../constants/colors";
import PurchaseGiftCardDialog from "./PurchaseGiftCardDialog";
import {ArrowLeftOutlined} from "@ant-design/icons";
import Actions from "../../../../../../redux/actions";
import { baseRouteMaker, routes } from "../../../../../../constants/routeConsts";
import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../../../common/spinner/Spinner";

const PurchaseGiftCard = () => {

  const {t} = useTranslation();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const { giftCards } = useSelector((state) => state.walletInfo);

  const [openPurchaseGiftCardDialog, setOpenPurchaseGiftCardDialog] =
    useState(false);

  const selectListApiCalls = () => {};

  useEffect(() => {
    selectListApiCalls();
  }, []);

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {};
    dispatch(getGiftCardsAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, []);

  /* Function to generate a random light gradient color */
  const generateRandomGradient = () => {
    const randomLightColor = () => Math.floor(Math.random() * 156) + 100; // Generate a lighter color
    const color1 = `rgb(${randomLightColor()}, ${randomLightColor()}, ${randomLightColor()})`;
    return color1;
  };
  /* Function to generate a random light gradient color */

  /* function definition to confirm purchase gift card */
  const handleConfirmPurchaseGiftCard = (element) => {
    const dataToBeSent = {
      ...element,
      event_type: "PURCHASE_GIFT_CARD",
    }
    dispatch(
      Actions.createAction(Actions.CONFIRM_PURCHASE_GIFT_CARD_DETAILS, {
        confirmPurchaseGiftCardDetails: dataToBeSent,
      })
    );
    setOpenPurchaseGiftCardDialog(true);
  };
  /* function definition to confirm purchase gift card */

  return (
    <Flex vertical gap="1rem">
      <Flex gap="1rem">
        <Button
          type="default"
          shape="circle"
          size="small"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(baseRouteMaker(routes.GIFT_CARD))}
        />
        <Title level={2}>{t(`Modules.PurchaseGiftCard.purchaseGiftCard`)}</Title>
      </Flex>
      {
        loading ? <Spinner/> :
        giftCards?.data?.length !== 0 ?
        <Row gutter={[24, 24]}>
          {giftCards?.data?.map((element) => {
            const randomGradient = generateRandomGradient();
            return (
              <Col span={8}>
                <Card
                  className="cardContainer"
                  bordered
                  hoverable
                  style={{
                    boxShadow: "1px 4px 8px rgba(0,0,0,0.1)",
                    background: "white",
                    border: `2px solid ${randomGradient}`,
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    padding: 20,
                    borderRadius: 14,
                  }}
                  onClick={() => handleConfirmPurchaseGiftCard(element)}
                >
                  <Typography.Title
                    level={3}
                    style={{ color: "#a2a3a6"}}
                  >
                    {element?.gift_card_name || "-"}
                  </Typography.Title>
                  <Typography.Title
                    level={3}
                    style={{ margin: "10px 0", color: colors.limeGreen }}
                  >
                    {`${element?.wallet_points} ${t("CommonUtils.points")}`}
                  </Typography.Title>
                  <Typography.Title
                    level={2}
                    style={{ margin: "10px 0", color: colors.electricBlue }}
                  >
                    {`${element?.amount?.toFixed(2)} ${element?.currency}`}
                  </Typography.Title>
                  
                </Card>
              </Col>
            );
          })}
        </Row>
        :
        <Empty description={t("Modules.PurchaseGiftCard.noGiftCardsAvailable")}/>
      }
      <PurchaseGiftCardDialog
        open={openPurchaseGiftCardDialog}
        onClose={() => {
          setOpenPurchaseGiftCardDialog(false);
        }}
      />
    </Flex>
  );
};

export default PurchaseGiftCard;
